export const LOGO = "/moon-logo.jpeg";
export const instagram = "https://www.instagram.com/_moonmedia_official/";
export const email = "moonmediapartnerships@gmail.com";

export const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Creators", to: "/creators" },
  { label: "Our Work", to: "/work" },
  { label: "Why Moon", to: "/why" },
  { label: "Contact", to: "/contact" },
];

export const services = [
  ["01", "Influencer Marketing", "End-to-end creator campaigns across relevant categories and platforms."],
  ["02", "Creator Partnerships", "Strategic collaborations between brands and creators based on audience and campaign fit."],
  ["03", "UGC & Content Creation", "Authentic creator-led content designed for brand communication and performance marketing."],
  ["04", "Regional Influencer Campaigns", "Creators across Indian languages, cities and regional markets."],
  ["05", "Performance & Paid Amplification", "Creator content built for usage rights, whitelisting and paid amplification."],
  ["06", "Campaign Management", "Creator sourcing, negotiations, coordination, content tracking, approvals and execution."],
];

export const categories = ["Beauty & Skincare", "Fashion & Lifestyle", "Fitness & Wellness", "Food", "Travel", "Technology", "Finance", "Automotive", "Home & Decor", "Parenting", "Pets", "Education", "Entertainment", "Regional Creators", "UGC Creators"];

export const criteria = ["Platform", "Follower range", "Engagement", "Audience demographics", "Location", "Language", "Content niche", "Campaign objective", "Budget"];

export const principles = [
  ["Relevant Creators", "We focus on creators who make sense for your audience and campaign."],
  ["Curated, Not Random", "Every creator shortlist is built around the specific campaign brief."],
  ["Regional Expertise", "Access creators across languages, cities and regional audiences."],
  ["End-to-End Execution", "From sourcing and negotiation to content coordination and campaign completion."],
  ["Brand-Creator Alignment", "We look beyond follower count to understand content style, audience relevance and brand fit."],
  ["Transparent Communication", "Clear commercials, deliverables, timelines and campaign expectations."],
];

export const processSteps = ["Share Your Brief", "Creator Discovery", "Shortlist & Commercials", "Content & Approvals", "Campaign Go-Live"];

export const workedWith = ["Sugarfit", "Plix", "Renee Cosmetics", "Bella Vita", "Flo Mattress", "Bhanzu", "Senses", "Fraganote", "Protouch", "Ghar Soaps", "CRED", "Yes Madam", "Kenaz Perfume", "Indian Secrets"];

export const campaignExpertise = [
  ["Regional Influencer Campaigns", "Ghar Soaps and other regional campaigns featuring creators in different languages and markets, tailored to regional audiences."],
  ["Nano, Micro & Macro Creators", "Campaigns across creator tiers, from niche nano influencers to established macro creators, based on brand objectives and audience fit."],
  ["Travel & Lifestyle Collaborations", "Travel-focused barter collaborations featuring cameras and other travel-related products, with creators producing authentic lifestyle content."],
  ["Barter Collaborations", "Product-led collaborations across beauty, wellness, lifestyle and travel, connecting brands with relevant creators."],
];

export const marqueeItems = ["Influence, With Intention", "Relevance Over Random Reach", "The Right Creators For The Right Campaign", "Regional Voices, National Brands"];
